// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SeasonalDiscountUnibrow-cls1___c95060d44af842a4b41{/*!*/}.SeasonalDiscountUnibrow-cls2___ce18f971b7de831789c{font-size:20px;font-weight:400;letter-spacing:.03em;margin:0;opacity:.8;text-transform:uppercase}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SeasonalDiscountUnibrow-cls1___c95060d44af842a4b41",
	"cls2": "SeasonalDiscountUnibrow-cls2___ce18f971b7de831789c SeasonalDiscountUnibrow-cls1___c95060d44af842a4b41"
};
export default ___CSS_LOADER_EXPORT___;
